import React from 'react';
import { Button, Flex, Form, Input, InputNumber, Modal } from 'antd';

interface NewTabFormValues {
  key: string;
  label: string;
  index: number;
}

interface AdminNewTabModalProps {
  open: boolean;
  onCancel: () => void;
  notAllowedKeys: string[];
  defaultIndex: number;
  onAdded: (tab: NewTabFormValues) => void;
}

const AdminNewTabModal: React.FC<AdminNewTabModalProps> = ({ open, onCancel, notAllowedKeys, defaultIndex, onAdded }) => {
  const [form] = Form.useForm<NewTabFormValues>();

  const handleFinish = ({ key, label, index }: NewTabFormValues) => {
    onAdded({ key: key.trim(), label: label.trim(), index: Number(index) });
    form.resetFields();
  };

  return (
    <Modal
      title="Ajouter un onglet"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{ key: '', label: '', index: defaultIndex }}
      >
        <Form.Item
          name="key"
          label="Clé"
          extra="Identifiant technique de l'onglet (la clé JSON)."
          rules={[
            { required: true, message: 'Veuillez entrer une clé' },
            {
              validator: (_, value) =>
                value && notAllowedKeys.includes(value.trim())
                  ? Promise.reject(new Error('Cette clé existe déjà'))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input placeholder="ex: telephony" autoComplete="off" />
        </Form.Item>

        <Form.Item
          name="label"
          label="Label"
          extra="Nom affiché sur l'onglet (les emojis sont convertis en icônes)."
          rules={[{ required: true, message: 'Veuillez entrer un label' }]}
        >
          <Input placeholder="ex: 📞 Téléphonie" autoComplete="off" />
        </Form.Item>

        <Form.Item
          name="index"
          label="Index"
          extra="Position de l'onglet (le plus élevé est affiché en premier)."
          rules={[{ required: true, message: 'Veuillez entrer un index' }]}
        >
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>

        <Flex justify="flex-end" gap={8}>
          <Button onClick={onCancel}>Annuler</Button>
          <Button type="primary" htmlType="submit">Ajouter</Button>
        </Flex>
      </Form>
    </Modal>
  );
};

export default AdminNewTabModal;
